export const CONTRIBUTION_STORE_STATE_SYMBOL = Symbol.for("@visactor/vrender-core/contribution-store-state");

function createContributionStoreState() {
    return {
        store: new Map
    };
}

export function getContributionStoreState() {
    const scope = globalThis;
    return scope[CONTRIBUTION_STORE_STATE_SYMBOL] || (scope[CONTRIBUTION_STORE_STATE_SYMBOL] = createContributionStoreState()), 
    scope[CONTRIBUTION_STORE_STATE_SYMBOL];
}
//# sourceMappingURL=contribution-store-state.js.map